import {
  type GetSubLevelBreakdown_me_adObject_subLevelBreakdown_rows,
  type SalesPageMetric,
} from "@north-beam/nb-client-side";
import {
  type DateInterval,
  isWithinDateInterval,
  metrics as metricsPkg,
  type CurrencyCode,
} from "@north-beam/nb-common";

export const processForTable = (
  rows: GetSubLevelBreakdown_me_adObject_subLevelBreakdown_rows[],
  metricsArray: SalesPageMetric[],
  dateRange: DateInterval,
  code: CurrencyCode,
) => {
  const rv = [];
  const rest = [];

  for (const row of rows) {
    const metrics = metricsPkg.newMetricPoint();

    for (const dailyMetric of row.dailyMetrics ?? []) {
      if (isWithinDateInterval(dailyMetric.date.substring(0, 10), dateRange)) {
        metricsPkg.addToMetricPoint(metrics, dailyMetric);
      }
    }

    rv.push({
      id: row.link.replace("objects/", ""),
      name: row.name,
      key: row.objectId,
      metrics,
    });
  }

  for (const row of rv) {
    const display: Record<string, unknown> = {};

    for (const metric of metricsArray) {
      const current = metric.calculate(row.metrics);
      display[metric.id] = metric.formatter(current, code, {
        precision: "exact",
      });
    }

    rest.push({
      id: row.id,
      name: row.name,
      key: row.key,
      metrics: row.metrics,
      display,
    });
  }

  const metricsTotal = metricsPkg.newMetricPoint();
  const displayTotal: Record<string, unknown> = {};

  for (const row of rv) {
    metricsPkg.addToMetricPoint(metricsTotal, row.metrics);
  }

  for (const metric of metricsArray) {
    const current = metric.calculate(metricsTotal);
    displayTotal[metric.id] = metric.formatter(current, code, {
      precision: "exact",
    });
  }

  const total = { name: "Total", key: "total", display: displayTotal };

  return { total, rest } as const;
};
